module.exports = __webpack_public_path__ + "media/images/user-c03556e29850fd18b3fd181000213ae0.svg";